import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule } from '@angular/common/http';

import { VendorModule } from '../core/vendor.module';

import { CoreModule } from '../core/core.module';
import { SecurityService } from '../security/security.service';
import { ConfiguracionComponent } from './configuracion.component';
import { LoguedGuardService } from '../security/logued-guard.service';
import { ConfiguracionResolver } from './configuracion.resolver';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SecurityModule } from '../security/security.module';
import { SharedServicesModule } from '../shared-services/shared-services.module';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
    SecurityModule,
  ],
  declarations: [
    ConfiguracionComponent
  ],
  exports: [
    ConfiguracionComponent
  ],
  providers: [
    SecurityService,
    LoguedGuardService,
    ConfiguracionResolver
  ]
})
export class ConfiguracionModule { }



// WEBPACK FOOTER //
// ./src/app/configuracion/configuracion.module.ts